// src/MenuCategorias.jsx

import React, { useEffect, useState } from 'react';
import bk from './assets/bk.png'; // Ajusta la ruta según tu proyecto
import { getData, getImage } from '../../../helpers/indexedDbHelper';
import { useRefresh } from '../../../hooks/useRefresh';
import ListProducts from '../ListProducts';

export default function MenuCategorias({setShowEntress}) {
  const wrapperStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
      zIndex: 999,
    background: '#FF0000',
    backgroundImage: `url(${bk})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    flexDirection: 'column',
    color: '#fff',
    fontFamily: 'sans-serif',
  };

  const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1rem',
  };

  const backButtonStyle = {
    background: '#000',
    color: '#fff',
    padding: '0.5rem 3rem',
    borderRadius: '4px',
    border: 'none',
    cursor: 'pointer',
    fontWeight: '900',
    fontSize: 20
  };

  const socialStyle = {
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'center',
    fontSize: '1.25rem',
  };

  const titleContainer = {
    textAlign: 'center',
    marginTop: '2rem',
  };

  const titleStyle = {
    display: 'inline-block',
    background: '#000',
    color: '#fff',
    padding: '1rem 3rem',
    borderRadius: '4px',
    fontSize: '1.25rem',
  };

  const buttonsContainer = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '0 1rem',
  };

  const categoryButton = {
    width: '100%',
    maxWidth: '320px',
    height: 70,
    margin: '0 auto',
    padding: '1rem',
    fontSize: '1rem',
    background: '#fff',
    color: '#e63946',
    border: '4px solid #f4a261',
    borderRadius: '10px',
      cursor: 'pointer',
    
  };

  const footerStyle = {
    textAlign: 'center',
    padding: '1rem',
    fontSize: '0.65rem',
    lineHeight: '1.4',
    background: 'rgba(0,0,0,0.5)',
  };

   const [showListProduct, setShowListProduct] = useState(false);
   const [dishs, setdishs] = useState(false);
   const {change} = useRefresh();
  const [menus, setMenus] = useState([]);
  const [steak, setsteak] = useState(false);
    const [chicken, setchicken] = useState(false);
    const [fish, setfish] = useState(false);
    const [pork, setpork] = useState(false);


   useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);

  
  useEffect(() => {
        menus.map((item) => {
        if (item.id === 574) {
            setsteak(item);
        }
          if (item.id === 575) {
            setchicken(item);
          }
        if (item.id === 577) {
            setfish(item);
        }
            if (item.id === 576) {
            setpork(item);
        }
        });
  }, [menus]);
  
  
  return (
    <div style={wrapperStyle}>
      {/* Header */}
      <div style={headerStyle}>
        <button
          style={backButtonStyle}
          onClick={() => setShowEntress(false)}
        >
          Volver
        </button>
        <div style={socialStyle}>
          {/* Usamos emojis en lugar de librerías */}
          {/* <span role="img" aria-label="web">🌐</span>
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#fff', textDecoration: 'none' }}
          >
            <span role="img" aria-label="facebook">📘</span>
          </a>
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#fff', textDecoration: 'none' }}
          >
            <span role="img" aria-label="instagram">📸</span>
          </a> */}
        </div>
      </div>
      <br /><br /><br /><br />
      <br /><br /><br /><br />
     
      {/* Título */}
      <div style={titleContainer}>
        <h2 style={titleStyle}>ENTREES / PLATOS FUERTES</h2>
      </div>
      
        

      {/* Botones de categorías */}
      <div style={buttonsContainer}>
        {['steaks/carnes', 'chicken/pollo', 'fish/pescado', 'pork/cerdo'].map(label => (
          <button key={label} style={categoryButton}
          
            onClick={() => {
              if (label === 'steaks/carnes') {
                 setShowListProduct(true)
                        setdishs(steak)    
              } else if (label === 'chicken/pollo') {
                 setShowListProduct(true)
                        setdishs(chicken)    
              }else if (label === 'fish/pescado') {
                 setShowListProduct(true)
                        setdishs(fish)    
              } else {
                setShowListProduct(true)
                        setdishs(pork)    
              }
            }}
          >
            <p style={{fontWeight: '900', textTransform: 'uppercase'}}>{label}</p>
          </button>
        ))}
      </div>

      {/* Footer */}
      {/* <div style={footerStyle}>
        <p>
          (1) Please inform the waiter if you have any type of allergic condition;&nbsp;
          (2) Price subject to change without notice;&nbsp;
          (3) 18% gratuity will be added to invoice $100+
        </p>
        
      </div> */}

      {showListProduct && <ListProducts
          top={-6}
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}

    </div>
  );
}
